// extracted by mini-css-extract-plugin
export default {"spacingTop":"HolidayProvider_spacingTop__YXTbW"};